import React from 'react';

export function P({ children, className }) {
    return (
        <p className={className}>
            {children}
        </p>
    )
}